var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormLabel } from 'shared/components';
import { useDeprecationIsOverridden, useFieldIsDeprecated } from '../hooks';
/**
 * Form label that shows one of two different values depending on if another deprecated form field is present.
 * For use cases where a full schema change is not neccessarily needed, but changed labels could create confusion
 * on old notes.
 */
export var VersionedFormLabel = function (_a) {
    var deprecatedName = _a.deprecatedName, deprecatedLabel = _a.deprecatedLabel, _b = _a.valueCheck, valueCheck = _b === void 0 ? function (value) { return !!value; } : _b, formLabelProps = __rest(_a, ["deprecatedName", "deprecatedLabel", "valueCheck"]);
    var _c = useFormContext(), getValues = _c.getValues, setValue = _c.setValue;
    var isDeprecated = useFieldIsDeprecated(deprecatedName);
    var isOverridden = useDeprecationIsOverridden(deprecatedName, valueCheck);
    useEffect(function () {
        // if field is deprecated and still is a draft, remove any value that may be set
        if (isDeprecated && !isOverridden && valueCheck(getValues(deprecatedName))) {
            setValue(deprecatedName, '');
        }
    }, [getValues, setValue, isOverridden, isDeprecated]);
    if (isDeprecated && !isOverridden) {
        return _jsx(FormLabel, __assign({}, formLabelProps));
    }
    return _jsx(FormLabel, { children: deprecatedLabel });
};
